/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Divider, {DividerProps} from '@material-ui/core/Divider';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '@ion/dls/src/theme/theme';

const useStyles = makeStyles(theme => ({
  root : {
    backgroundColor                       : dlsColor('grey5'),
    width                                 : '100%',
    [theme.breakpoints.between(200, 950)] : { // mobile phones and tablets
      height : '2px'
    }
  }
}));

/**
 * @Divider
 *
 * Defines the Divider component. This component is reusable and can be custom
 * rendered with props.
 * https://www.figma.com/file/srjlHrDuM90sCoaOwpjaDU/01_DLS_Components?node-id=1952%3A15594
 *
 * ```typescript
 *
 *   <Divider component='li' variant='middle' />
 *
 * ```
 */
const DividerWrapper = ({...props}: DividerProps) => {
  const classes = useStyles();
  return <Divider classes={classes} {...props} />;
};

export default DividerWrapper;
